function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import getRandomHumanId from "./getRandomHumanId.js";
export default function assignErrorId(e) {
  var _err$errors, _err$extensions;
  var isObj = _typeof(e) === 'object' && e !== null;
  var err = e;
  var existingId = isObj && (((_err$errors = err.errors) === null || _err$errors === void 0 || (_err$errors = _err$errors[0]) === null || _err$errors === void 0 || (_err$errors = _err$errors.extensions) === null || _err$errors === void 0 ? void 0 : _err$errors.id) || ((_err$extensions = err.extensions) === null || _err$extensions === void 0 ? void 0 : _err$extensions.id) || err.id);
  var errId = existingId || "".concat(getRandomHumanId(), "-").concat(new Date().getDate());
  if (isObj && err.id !== errId) {
    err.id = errId;
  }
  return errId;
}